// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var OAuthGrantsController = function ($scope, OAuthGrant) {
    $scope.grants = OAuthGrant.query();
};
OAuthGrantsController.$inject = ['$scope', 'OAuthGrant'];
